<template>
    <div>
        <div v-if="loading"
             :class="`loader ${(absolute) ? 'abs' : ''}`"
        >
            <div class="loader-content" >
                <img src="/img/loading.gif" alt="Загрузка...">
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['loading', 'absolute','background'],
    }
</script>

<style lang="scss">

    .loader {
        z-index: 2;
        position: fixed;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        width: 100%;
        height: 100%;
        text-align: center;
        &-content {
            background: #fff;
            position: relative;
            height: 100%;
            width: 100%;
            img {
                position: absolute;
                left: calc(50% - 30px);
                top: calc(50% - 30px);
                width: 60px;
                height: 60px;

            }
        }
    }


    .loader.abs {
        position: absolute !important;
    }


    .loaderParent {

        height: 60px;
        position: relative;

        .loader {


        }
    }

</style>
